<template>
  <div class="container-fluid">
    <div class="row">
      <sidebar></sidebar>
      <nav-header></nav-header>
      
      <template v-if="user.studyLevel === 13">
        <short-term />
      </template>
      

      <!-- MAIN CONTENT start -->
      <main v-else role="main" class="col-12 col-sm-9 col-md-10 ml-sm-auto col-lg-10">
        <sidebar-sm></sidebar-sm>
        <breadcrumb :items="pageData.breadcrumb"></breadcrumb>

          <!-- first friend-->
 
<div class="contact-card p-4 p-md-5" v-if="firstFriend.length>0">
    <div class="card-flex">

      <!-- LEFT: person info -->
      <div class="flex-grow-1">
        <div class="person-flex d-flex align-items-start">
          <img
            class="avatar flex-shrink-0"
            :src="'data:image/jpeg;base64,'+firstFriend[0].img"
            :alt="firstFriend[0].person">

          <div>
            <div class="contact-name">{{ firstFriend[0].person }}</div>
            <div class="contact-role mb-3">{{ firstFriend[0].full_position }}</div>
            <p class="contact-desc mb-0">
                მე ვიქნები თქვენი მომსახურების მენეჯერი პირველი სემესტრის განმავლობაში. 
                სასწავლო პროცესთან და ადმინისტრაციულ საკითხებთან დაკავშირებული კითხვების შემთხვევაში შეგიძლიათ მომმართოთ.
            </p>
          </div>
        </div>

        <!-- contact pills -->
        <div class="d-flex flex-wrap mt-4">
          <a :href="'mailto:'+firstFriend[0].email_ug" class="pill-btn text-decoration-none mr-3 mb-2">
            <i class="bi bi-envelope"></i> {{ firstFriend[0].email_ug }}
          </a>
          <a href="tel:0322552222" class="pill-btn text-decoration-none mb-2">
            <i class="bi bi-telephone"></i> 0322552222
          </a>
        </div>
      </div>

      <!-- DIVIDER -->
      <div class="divider d-none d-lg-block mx-2"></div>
     <router-link :to="'/first-friend/'+firstFriend[0].personID"> 
      <!-- RIGHT: working hours -->
      <div class="flex-shrink-0" style="min-width: 220px;">
        <div class="hours-title mb-2">
          <i class="bi bi-clock"></i> სამუშაო საათები
        </div>
        <div class="hours-text">ორშაბათი - პარასკევი</div>
        <div class="hours-text mb-3">10:00 - 18:00</div>

       
      </div>
 
      <!-- CHEVRON -->
      <div class="align-self-start d-none d-lg-block">
       დეტალურად <i class="bi bi-chevron-right chevron"></i>
      </div>
</router-link>
    </div>
  </div>



          <!-- first friend end-->


   
        <p class="f-p2 text-center" style="font-size: 20px;color:red">{{ helpers.getLocalizedField(user, 'studentStatus') }}</p>


        <div class="mx-auto d-flex align-items-center justify-content-center" v-if="user.missedDocuments" style="background-color:#cb2026; width: 70%; min-height: 80px; border-radius: 10px;">
          <p v-for="missedDocument of user.missedDocuments" class="text-white" style="font-size: 15px;">

            <span v-if="$i18n.locale=='ka'">მოგესალმებით,
            გთხოვთ,სასწავლო ოფისში დაუყოვნებლივ წარმოადგინოთ  {{ helpers.getLocalizedField(missedDocument, 'document_name')  }}, 
             {{ missedDocument.last_date.slice(0,10) }}-მდე</span>

            
             <span v-if="$i18n.locale=='en'">
              
              Greetings,
              Please, present the {{ helpers.getLocalizedField(missedDocument, 'document_name')  }} urgently till {{ missedDocument.last_date.slice(0,10) }}, at the study office.
 
              </span>
          
          </p>

        </div>



        <!-- CALENDAR -->
        <section class="calendar-section pb-4">
          <div class="event-cards-wrapper">
            <div class="event-card-slider">
              <div class="slides">
                <upload-docs-modal v-if="mustUploadDocs"></upload-docs-modal>
<!--                <distance-final-modal v-if="locale === 'ka'"></distance-final-modal>-->
                <modal-message :key="message.modal_messageID" v-for="message of messages" :message="message"></modal-message>
              </div>
            </div>
          </div>
          <div class="calendar-wrapper">
            <calendar></calendar>
          </div>
        </section>
      </main>
      <!-- MAIN CONTENT end -->
    </div>
  </div>
</template>

<script>
import sidebar from '../components/navbar/sidebar';
import breadcrumb from '../components/page/breadcrumb';
import sidebarSm from '../components/navbar/sidebar-sm';
import navHeader from '../components/navbar/nav-header';
import pageTitle from '../components/page/page-title';
import { mapGetters } from 'vuex';
import ModalMessage from '../components/home/modal-message';
import UploadDocsModal from '../components/home/upload-docs-modal';
import Calendar from '../components/home/calendar';
import DistanceFinalModal from '../components/distance-finals/distance-final-modal';
import ShortTerm from '../components/short-term/short-term'
import firstFriendResource from '../api/firstFriendResource';
 

const firstFriendResourceObj=new firstFriendResource()

export default {
  name: 'Home',
  components: { DistanceFinalModal, ShortTerm, Calendar, breadcrumb, ModalMessage, UploadDocsModal, sidebar, navHeader, pageTitle, sidebarSm },
  computed: {
    pageData() {
      return {
        title: this.$t('home.title'),
        breadcrumb: [{
          icon: '',
          title: this.$t('home.title'),
          link: '/',
          isActive: true,
        }],
      };
    },

    ...mapGetters({
      messages: 'popup_messages/messages',
      mustUploadDocs: 'auth/mustUploadDocs',
      user: 'auth/user',
      locale: 'language/locale',
    }),
  },

  mounted() {
    this.$store.dispatch('popup_messages/loadMessages');

    firstFriendResourceObj.getFirstFriend().then(response=>{

      this.firstFriend=response.data


    })
    
  },
  data(){
    return{
      firstFriend:[]
    }
  }
};
</script>

<style scoped>
 .contact-card {
      border: 1px solid #f6d5d5;
      border-radius: 20px;
      background: #fff;
      box-shadow: 0 8px 24px rgba(0, 0, 0, .03);
      max-width: 1180px;
      margin: 0 auto;
    }

    .avatar {
      width: 96px;
      height: 96px;
      border-radius: 50%;
      object-fit: cover;
    }

    .contact-name {
      font-weight: 700;
      font-size: 1.25rem;
      color: #1f2937;
    }

    .contact-role {
      color: #6b7280;
      font-size: .95rem;
    }

    .contact-desc {
      color: #6b7280;
      font-size: .9rem;
      line-height: 1.55;
      max-width: 460px;
    }

    /* pill buttons (email / phone) */
    .pill-btn {
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      background: #fff;
      color: #374151;
      font-size: .9rem;
      padding: 10px 16px;
      display: inline-flex;
      align-items: center;
      white-space: nowrap;
    }
    .pill-btn i { color: #9ca3af; margin-right: 10px; }

    .divider {
      width: 1px;
      background: #eee;
      align-self: stretch;
    }

    .hours-title {
      font-weight: 700;
      color: #1f2937;
      display: inline-flex;
      align-items: center;
    }
    .hours-title i { color: #9ca3af; margin-right: 8px; }

    .hours-text { color: #4b5563; font-size: .95rem; }

    .btn-write {
      background: #e11d1d;
      border: none;
      color: #fff;
      border-radius: 10px;
      padding: 12px 28px;
      font-weight: 600;
      display: inline-flex;
      align-items: center;
    }
    .btn-write i { margin-right: 10px; }
    .btn-write:hover { background: #c81717; color: #fff; }

    .chevron {
      color: #9ca3af;
      font-size: 1.4rem;
    }

    /* Bootstrap 4 has no gap utilities — recreate the spacing */
    .card-flex { display: flex; align-items: center; }
    .card-flex > * + * { margin-left: 1.5rem; }
    .person-flex > * + * { margin-left: 1.5rem; }

    @media (max-width: 767.98px) {
      .person-flex { flex-direction: column; align-items: flex-start; }
      .person-flex > * + * { margin-left: 0; margin-top: 1rem; }
    }
</style>
